<template>
    <a-modal title="编辑购标供应商"
             :width="1200"
             :visible="visible"
             @ok="onEditSave"
             :destroyOnClose="true"
             :maskClosable="false"
             @cancel="$emit('cancel')">
        <div>
            <a-card>
                <a-form :form="supperEditForm" class="pick-100">
                    <a-row type="flex" justify="space-between" class="form-input about">
                        <a-col :span="11">
                            <a-form-item label="供应商名称">
                                <a-input placeholder="供应商名称"
                                         v-decorator="['supplierName',{initialValue:supperEditData.supplierName, rules: [{ required: true, message: '请输入供应商名称' }]}]"></a-input>
                            </a-form-item>
                        </a-col>
                        <a-col :span="11">
                            <a-form-item label="供应商类型" >
                                <a-radio-group  @change="e=> setSupplierType(e.target.value)" disabled="disabled"
                                                v-decorator="['supplierType',{ initialValue:supperEditData.supplierType, rules: [{ required: true, message: '请输入供应商类型' }]}]">
                                    <a-radio value="3">企业</a-radio>
                                    <a-radio value="2">个体户</a-radio>
                                    <a-radio value="1">个人</a-radio>
                                </a-radio-group>
                            </a-form-item>
                        </a-col>
                        <a-col :span="11" v-if="supperEditData.supplierType==='1'">
                            <a-form-item label="身份证号">
<!--                                <a-input placeholder="身份证号" :disabled="supperEditData.signType==='1'"-->
                                <a-input placeholder="身份证号" disabled="disabled"
                                         v-decorator="['supplierCode',{initialValue:supperEditData.supplierCode, rules: [{ required: true, message: '请输入身份证号' },{pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,message: '身份证号码格式不正确'}]}]"></a-input>
                            </a-form-item>
                        </a-col>
                        <a-col :span="11" v-else>
                            <a-form-item label="信用代码">
                                <a-input placeholder="统一社会信用代码" disabled="disabled"
                                         v-decorator="['supplierCode',{initialValue:supperEditData.supplierCode, rules: [{ required: true, message: '请输入统一社会信用代码' },{
                validator: checkCode}]},]"></a-input>
                            </a-form-item>
                        </a-col>
                        <a-col :span="11">
                            <a-form-item label="购标时间">
                                <a-date-picker  format="YYYY-MM-DD HH:mm"
                                                v-decorator="['regDate', {initialValue:supperEditData.regDate, rules: [{ required: true, message: '请输入购标时间' }]}]"/>
                            </a-form-item>
                        </a-col>
                        <a-col :span="11">
                            <a-form-item label="联系人">
                                <a-input placeholder="联系人"
                                         v-decorator="['contacts',{ initialValue:supperEditData.contacts,rules: [{ required: true, message: '请输入联系人' }]}]"></a-input>
                            </a-form-item>
                        </a-col>
                        <a-col :span="11">
                            <a-form-item label="联系人手机号">
                                <a-input placeholder="联系人手机号"
                                         v-decorator="['mobile',{initialValue:supperEditData.mobile,
                                      rules: [{ required: true, message: '请输入手机号' },{
                validator: checkTel}]},]"></a-input>
                            </a-form-item>
                        </a-col>
                        <a-col :span="11">
                            <a-form-item label="联系人办公电话">
                                <a-input placeholder="联系人办公电话"
                                         v-decorator="['telephone',{ initialValue:supperEditData.telephone}]"></a-input>
                            </a-form-item>
                        </a-col>
                        <a-col :span="11">
                            <a-form-item label="电子邮件">
                                <a-input placeholder="电子邮件"
                                         v-decorator="['supplierEmail',{ initialValue:supperEditData.supplierEmail,rules: [{
                validator: checkEmail}]},]"></a-input>
                            </a-form-item>
                        </a-col>
                    </a-row>
                </a-form>
            </a-card>
        </div>
    </a-modal>
</template>

<script>
  import { PageView } from '@/layouts'
  import qs from 'qs'
  import DictCascader from '../../../components/dict/DictCascader'
  import moment from 'moment'
  import {EditDemandAttendGys} from '../../demandsurveybid/SurveyBidRequest'

  const uuidv4 = require('uuid/v4')
  export default {
    name: 'AttendSupperAdd',
    props: ['visible','packId'],
    components: {
      PageView,
      DictCascader,
      moment
    },
    data () {
      return {
        supperEditForm: this.$form.createForm(this),
        supperEditData:{}
      }
    },
    mounted () {
    },
    created () {
    },
    methods: {
      setSupplierType(val)
      {
        this.supperEditData.supplierType=val
      },
      getSupperEditData(id){
        const that = this
        if (!id)
        {
          that.$message.warning("参数错误，无法查看信息")
          return
        }
        this.$http.get('/api/1/signSupplier/getBidAttend.json?id=' + id).then(function (response) {
          if (200 === response.code)
          {
           response.result.regDate =  response.result.regDate?moment(response.result.regDate):null
           that.supperEditData = response.result
          }
        })
      },
      // 校验联系人邮箱
      checkEmail (rule, value, callback) {
        const reg =  /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/
        if (value && (!reg.test(value))) {
          callback(new Error('邮箱不符合规范'))
        } else {
          callback()
        }
      },
      // 校验联系人电话
      checkTel (rule, value, callback) {
        const reg = /^[1][3-9][0-9]{9}$/
        if (value && (!reg.test(value))) {
          callback(new Error('手机号码不符合规范'))
        } else {
          callback()
        }
      },
      // 校验信用代码
      checkCode (rule, value, callback) {
        const reg = /[^_IOZSVa-z\W]{2}\d{6}[^_IOZSVa-z\W]{10}/g
        if (value && (!reg.test(value))) {
          callback(new Error('统一信用代码不符合规范'))
        } else {
          callback()
          // this.$http.get('/api/1/apply/checkPurchaser.json?purchaserCode=' + value).then(function (response) {
          //   if (response.code === 200) {
          //     callback()
          //   } else {
          //     callback(new Error(response.msg))
          //   }
          // })
        }
      },
      async saveEditData () {
        const that = this
        let data = that.supperEditForm.getFieldsValue()
        console.log(that.supperEditData)
        data.id=that.supperEditData.id
        data.packId=that.supperEditData.packId
        data.projectId = that.supperEditData.projectId
        data.regDate= data.regDate?data.regDate.format('YYYY-MM-DD HH:mm') : null
        if ('4'===that.supperEditData.systemType)
        {
          var res = await EditDemandAttendGys(data)
          if (res.code !== 200) {
            that.$message.error('编辑失败')
            return
          }
          that.$message.success('编辑成功')
          that.$emit('success')
        }else {
        that.$http.post('/api/1/signSupplier/updateBidAttend.json', qs.stringify(data)).then(function (response) {
          if (response.code !== 200) {
            that.$message.error('编辑失败')
            return
          }
            that.$message.success('编辑成功')
            that.$emit('success')
        })
        }
      },
      onEditSave () {
        let that = this
        that.supperEditForm.validateFields((err, values) => {
          if (err) {
            return
          }
          that.saveEditData()
        })
      }
      ,
    }
  }
</script>

<style scoped>
</style>
